import React, { useEffect } from 'react';
import './tooltip.scss';
const colors = {
  primary: '#3d4a8f',
  'primary-dark': '#141f5b',
  secondary: '#00798c',
  'secondary-light': '#85cd95',
  'secondary-dark': '#03353d',
  success: '#00c853',
  info: '#126eab',
  warning: '#ffc107',
  gold: 'goldenrod',
  notice: '#ff8c00',
  danger: '#dc2633',
  white: '#fff',
  dark: '#343a40',
};
const Tooltip = ({
  content,
  children,
  position,
  textColor = colors.white,
  backgroundColor = colors.warning,
  direction,
  customClassName,
  contentClassName = 'd-flex',
  contentXPadding = 'px-2',
}) => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--tooltip-background-color',
      colors[backgroundColor],
    );
    document.documentElement.style.setProperty(
      '--tooltip-text-color',
      colors[textColor],
    );
  }, [backgroundColor, textColor]);

  return (
    <div
      className={`custom-tooltip custom-tooltip-${position} ${
        customClassName || ''
      }`}
    >
      {content?.length === 0 ? (
        <>{children}</>
      ) : (
        <>
          <div
            className={`w-100 ${contentClassName} position-relative justify-content-center tooltip-box tooltip-${position} ${contentXPadding}`}
          >
            <span
              className={`position-absolute custom-tooltip-text text-wrap direction-${direction}`}
            >
              {content}
            </span>
            <span className={`position-absolute arrow-${position}`}></span>
          </div>
          {children}
        </>
      )}
    </div>
  );
};
export default Tooltip;
